<template>
  <div class="user-details-container">
    <div class="details-component__content content">
      <div class="content__cell">
        <table class="details-table">
          <tr class="details-table__row" v-if="canUseCards()">
            <td class="details-table__col details-table__col_label"
              :class="{ 'form__field_error': errors.has('parkingCardNr') }">{{ $t('common.card_number') }}</td>
            <td class="details-table__col">
              <el-input :placeholder="$t('common.card_number')" name="parkingCardNr" id="parkingCardNr"
                class="parkingCardNrInput-toggle" v-model="form.parkingCardNr" v-validate="'validParkingCardNr'"
                :data-vv-as="$t('add_permit.parking_card_id')" data-vv-delay="1000" ref="parkingCardNrInput"
                @keyup.enter.native="toggleInput('parkingCardNrInput');" :disabled="permitChangeDisabled">
                <el-button
                  :class="{ 'parkingCardNrInput-toggle': parkingCardNrInputDisabled, 'on-click-trigger-submit2': !parkingCardNrInputDisabled }"
                  slot="append" :icon="parkingCardNrInputDisabled || permitChangeDisabled ? 'el-icon-edit' : ''"
                  :disabled="permitChangeDisabled">{{ parkingCardNrInputDisabled || permitChangeDisabled ? '' :
                    $t('common.ok') }}</el-button>
              </el-input>
              <tooltip v-show="errors.has('parkingCardNr')" class="form__validation">{{ $t('errors.valid_card_field') }}
              </tooltip>
              <!--<tooltip v-show="errors.has('vehicleReg')" class="form__validation">{{ $t('errors.card_user_field_required') }}</tooltip>-->
            </td>
          </tr>

          <tr class="details-table__row">
            <td class="details-table__col details-table__col_label">{{ $tc('common.user_vehicle_reg', 1) }}</td>
            <td class="details-table__col">
              <div class="el-input__inner el-input__inner--vehicle-reg">{{ selectedVehicle.vehicleReg }}</div>
              <el-button v-if="!permitChangeDisabled" class="btn btn--change" @click="showListModalVehicle()"
                slot="append">{{ $t('common.change') }} {{ $tc('common.plate', 1) }}</el-button>
            </td>
          </tr>

          <tr class="details-table__row" v-if="permit.parkingSpotNumber">
            <td class="details-table__col details-table__col_label">{{ $t('permits.parking_spot_number') }}</td>
            <td class="details-table__col">{{ permit.parkingSpotNumber }}</td>
          </tr>

          <tr class="details-table__row">
            <td class="details-table__col details-table__col_label">{{ $t('common.zone') }}</td>
            <td class="details-table__col" v-if="permit.product">
              <span v-for="zone in permit.product.zones" :key="zone.id" class="el-tag">{{ zone.code }}&nbsp;</span>
            </td>
          </tr>

          <tr class="details-table__row" v-if="permit.product">
            <td class="details-table__col details-table__col_label">{{ $t('common.product') }}</td>
            <td class="details-table__col">{{ permit.product.name }}</td>
          </tr>

          <tr class="details-table__row" v-if="permit.partner">
            <td class="details-table__col details-table__col_label">{{ $t('common.issued_by') }}</td>
            <td class="details-table__col">{{ permit.partner.name }}</td>
          </tr>

          <tr class="details-table__row" v-if="permit.partner">
            <td class="details-table__col details-table__col_label">{{ $t('end_user.contact') }}</td>
            <td class="details-table__col">
              {{[permit.partner.contactPerson,
              permit.partner.phone
                ? parsePhoneNumber(permit.partner.phone, permit.partner.phoneCountry)
                : null,
              permit.partner.address]
                .filter(x => x !== null)
                .join(',&nbsp;')}}
            </td>
          </tr>

          <tr class="details-table__row" v-if="permit.validFromDate">
            <td class="details-table__col details-table__col_label">{{ $t('permits.valid_from_date') }}</td>
            <td class="details-table__col">{{ permit.validFromDate }}</td>
          </tr>

          <tr class="details-table__row" v-if="permit.expirationDate">
            <td class="details-table__col details-table__col_label">{{ $t('permits.expiration_date') }}</td>
            <td class="details-table__col">{{ permit.expirationDate }}</td>
          </tr>

        </table>
      </div>
      <div id="user-map-dom"></div>
    </div>

    <ListModal @cancel="closeListModal" @confirmed="confirmedListModal" v-if="showListModal">
      <template v-slot:default>
        <tr class="details-table__row details-table__row--vehicle">
          <td class="details-table__col details-table__col--vehicle">
            <div v-for="vehicle in vehicles.data" :id="'plate-' + vehicle.id"
              :class="vehicle.id === activePlate ? 'permit-edit-block active-border' : 'permit-edit-block'">
              <!-- edit permit row block -->
              <div :class="vehicle.id === selectedVehicle.id ?
                (vehicle.id === activePlate ? 'row-title' : 'row-title active-plate-bg')
                : 'row-title'">
                <!-- edit icon -->
                <div v-if="vehicle.id !== activePlate" class="edit-icon" @click="selectActivePlate(vehicle.id)" />
                <!-- plate number + parking icon -->
                <el-tag :key="vehicle.id" closable @click.native="selectVehicle(vehicle)" :disable-transitions="false"
                  @close.stop.prevent="removeVehicle(vehicle)"
                  :class="!vehicle.permitId ? vehicle.id === selectedVehicle.id ? 'el-tag--success' : '' : (vehicle.id === selectedVehicle.id && vehicle.id !== activePlate) ? vehicle.permits_count > 0 ? 'el-tag--success el-tag--permit' : 'el-tag--success' : vehicle.permits_count > 0 ? 'el-tag--permit' : ''"
                  role="select vehicle">
                  <div style="flex-direction: column; ">
                    <span class="vehicle-reg">{{ vehicle.vehicleReg }}</span>
                    <span v-if="vehicle.comment && vehicle.id !== activePlate" class="vehicle-comment">{{
                      vehicle.comment }}</span>
                    <span v-else-if="vehicle.id !== activePlate" class="vehicle-comment no-comment">&nbsp;</span>
                  </div>
                </el-tag>
              </div>

              <!-- comment edit form -->
              <div :id="'comment-block-' + vehicle.id" :ref="'comment-block-' + vehicle.id"
                :class="vehicle.id === activePlate ? 'active-edit' : 'hidden-edit'">
                <input class="vehicleInput-comment" :ref="`comment-${vehicle.id}`" :placeholder="$t('parking.comment')"
                  :value="vehicle.comment" />
                <!-- save/cancel buttons -->
                <div class="form__buttons buttonset">
                  <div class="buttonset__button btn btn--secondary btn--small" @click="selectActivePlate(0)">
                    {{ $t('common.cancel') }}
                  </div>
                  <button type="submit" class="buttonset__button btn btn--main btn--small"
                    :ref="`confirm-btn-${vehicle.id}`" @click.prevent.stop="saveComment(vehicle.id)">
                    {{ $t('common.confirm') }}
                  </button>
                </div>
              </div>
            </div>

            <!-- new plate number form -->
            <el-input id="vehicleReg" name="vehicleReg" class="vehicleInput-toggle" v-model="form.vehicleReg"
              v-validate="'max:15'" ref="vehicleInput" @keyup.enter.native="toggleInput('vehicleInput');"
              @keydown.native="stopInputAtDashAndSpace" v-if="!vehicleInputDisabled">
              <el-button
                :class="{ 'vehicleInput-toggle': vehicleInputDisabled, 'on-click-trigger-submit2': !vehicleInputDisabled }"
                slot="append">{{ $t('common.ok') }}</el-button>
            </el-input>
            <el-input class="vehicleInput-comment" name="vehicleComment" ref="vehicleComment"
              :placeholder="$t('parking.comment')" v-if="!vehicleInputDisabled" v-model="form.vehicleComment" />
            <el-button class="vehicle-input"
              :class="{ 'vehicleInput-toggle': vehicleInputDisabled, 'on-click-trigger-submit': !vehicleInputDisabled }"
              v-if="vehicleInputDisabled" @click="vehicleInputDisabled = false">
              {{ '+ ' + $t('add_permit.add_car') }}
              <i class="el-icon-edit el-icon-right"
                :class="{ 'vehicleInput-toggle': vehicleInputDisabled, 'on-click-trigger-submit': !vehicleInputDisabled }"></i>
            </el-button>
            <tooltip v-show="errors.has('vehicleReg:max')" class="form__validation to-bottom">{{ $tc('errors.field_max',
              1, { max: 15, have: form.vehicleReg ? form.vehicleReg.length : '' }) }}</tooltip>
          </td>
        </tr>
      </template>
    </ListModal>

    <WarningModal v-if="showWarningModal" @close="closeWarningModal">
      <h1 slot="header">{{ userWarningHeader }}</h1>
      <p slot="body">{{ userWarningBody }}</p>
    </WarningModal>
    <ConfirmationModal v-if="showConfirmationModal" @cancel="closeConfirmationModal" @confirmed="uncheckVehicleActive">
      <h1 slot="header">{{ $t('common.vehicle_reg') }}</h1>
      <p slot="body">{{ $t('vehicle.confirm_uncheck_active') }}</p>
    </ConfirmationModal>
  </div>
</template>

<script>
import Vue from 'vue';
import { sha256 } from 'js-sha256';
import { mapGetters } from 'vuex';
import moment from 'moment';
import * as mTypes from 'store/mutation-types';
import L from 'leaflet';
import { format } from 'libphonenumber-js';
import Tooltip from 'common/Tooltip';
import ConfirmationModal from 'common/ConfirmationModal';
import WarningModal from 'common/WarningModal';
import ListModal from 'common/ListModal';
import dechex from 'locutus/php/math/dechex';
import hexdec from 'locutus/php/math/hexdec';
import strpad from 'locutus/php/strings/str_pad';
import { sanitizeVehicleRegNumber } from '../../utils';

export default {
  components: {
    Tooltip,
    ConfirmationModal,
    WarningModal,
    ListModal,
  },
  computed: {
    ...mapGetters({
      permitError: 'permits/permit/error',
      permit: 'permits/permit/permit',
      coordinates: 'permits/permit/coordinates',
      user: 'user/user/user',
      users: 'users/user/user',
      vehicles: 'users/vehicles/vehicles',
      vehicleError: 'users/vehicles/error',
    }),
    selectedUser() {
      return this.user.data && this.user.data.selectedRole ? this.user.data.selectedRole.id : null;
    },
  },
  mounted() {
    this.initMap();

    this.mapInstance.on('load', () => {
      this.fetchAllData();
      this.resetValidators();
      this.createValidators();
      document.removeEventListener('click', window.eventListenerForEditViewPermit);
      window.eventListenerForEditViewPermit = this.handleInput;
      document.addEventListener('click', this.handleInput, false);
    });
  },
  watch: {
    $route: 'fetchAllData',
    vehicleComment: function (val) {
      this.value = val;
    }
  },
  data() {
    return {
      selectedUserHear: null,
      selectedVehicle: {
        id: null,
      },
      primordialSelectedVehicle: this.selectedVehicle,
      isPermitSelected: false,
      activePlate: null,
      form: {
        vehicleReg: '',
        vehicleComment: ''
      },
      triggerSubmit: false,
      parkingCardNrInputDisabled: true,
      vehicleInputDisabled: true,
      permitChangeDisabled: false,
      showConfirmationModal: false,
      showWarningModal: false,
      userWarningBody: null,
      userWarningHeader: null,
      zoom: 15,
      center: [24.707, 59.412],
      style: 'klokantech-basic',
      mapInstance: null,
      showListModal: false,
    };
  },
  methods: {
    initMap() {
      this.mapInstance = new mapboxgl.Map({
        container: 'user-map-dom',
        style: `${process.env.MAPS_URL}/styles/${this.style}/style.json`,
        hash: false,
        center: this.center,
        zoom: this.zoom,
      });
      this.mapInstance.addControl(new mapboxgl.NavigationControl());
    },
    cleanupCoordinates(coordinates) {
      let data = {};
      if (coordinates) {
        if (Array.isArray(coordinates) && coordinates[0] && coordinates[0].type === 'Feature') {
          data = {
            type: 'FeatureCollection',
            features: coordinates,
          };
        } else if (coordinates === Object(coordinates) && coordinates.type === 'Feature') {
          data = {
            type: 'FeatureCollection',
            features: [coordinates],
          };
        } else if (Array.isArray(coordinates) && coordinates[0] && coordinates[0].type === 'FeatureCollection') {
          const features = [];
          // eslint-disable-next-line
          for (const c of coordinates) {
            // eslint-disable-next-line
            for (const f of c.features) {
              features.push(f);
            }
          }
          data = {
            type: 'FeatureCollection',
            features,
          };
        } else if (coordinates === Object(coordinates) && coordinates.type === 'FeatureCollection') {
          data = coordinates;
        }
      }
      return data;
    },
    addSourceNLayers() {
      const id = sha256(JSON.stringify(this.coordinates));
      const data = this.cleanupCoordinates(this.coordinates, id);

      // Create source if not exists
      const source = this.mapInstance.getSource('zone-user-data');
      if (!source) {
        this.mapInstance.addSource('zone-user-data', {
          type: 'geojson',
          data,
        });
      } else {
        source.setData(data);
      }

      // Create layer if not exists
      if (!this.mapInstance.getLayer('zone-outline-user')) {
        this.mapInstance.addLayer({
          id: 'zone-outline-user',
          type: 'fill',
          source: 'zone-user-data',
          layout: {},
          paint: {
            'fill-color': '#088',
            'fill-opacity': 0.8,
          },
        });
      }
    },
    updateMap() {
      if (this.mapInstance && this.coordinates && this.coordinates.length > 0) {
        // Set center
        const bounds = L.geoJSON(this.coordinates).getBounds();
        if (bounds.isValid()) {
          const sw = bounds.getSouthWest();
          const ne = bounds.getNorthEast();
          const llb = new mapboxgl.LngLatBounds(sw, ne);
          this.mapInstance.fitBounds(llb, { padding: 20 });
        }
        Vue.nextTick(() => {
          if (this.coordinates && this.coordinates.length > 0) {
            if (this.mapInstance.isStyleLoaded()) {
              this.addSourceNLayers();
            } else {
              this.mapInstance.on('load', () => {
                this.addSourceNLayers();
              });
            }
          }
        });
      }
    },
    fetchAllData() {
      this.fetchPermit();
      this.fetchVehiclePlateNumbers();
    },
    closeConfirmationModal() {
      this.showConfirmationModal = false;
    },
    uncheckVehicleActive() {
      this.selectedVehicle.id = null;
      this.selectedVehicle.vehicleReg = null;
      this.closeConfirmationModal();
      this.onSubmit();
    },
    checkingNumberForPermit() {
      this.vehicles.data.forEach((vehicle) => {
        this.users.vehicles.forEach((item) => {
          if (vehicle.id === item.id) {
            vehicle.permitId = item.permitId;
          }
        });
      });
    },
    selectActivePlate(plateId) {
      this.activePlate = plateId
    },
    selectVehicle(vehicle) {
      this.selectedVehicle = vehicle;
    },
    toggleInput(buttonRef) {
      this.callSubmitIfInputIsEnabled(buttonRef);
      this[`${buttonRef}Disabled`] = !this[`${buttonRef}Disabled`];
      if (buttonRef !== 'vehicleInput') {
        this.blurInput(buttonRef);
      }
    },
    callSubmitIfInputIsEnabled(buttonRef) {
      if (!this[`${buttonRef}Disabled`]) {
        this.onSubmit();
      }
    },
    handleInput(event) {
      if (event.target && (event.target.classList.contains('on-click-trigger-submit2') || event.target.parentElement.classList.contains('on-click-trigger-submit2'))) {
        this.onSubmit();
      }
      let buttonRef = false;
      this.parkingCardNrInputDisabled = true;
      if (event.target && (event.target.classList.contains('parkingCardNrInput-toggle') || event.target.parentElement.classList.contains('parkingCardNrInput-toggle'))) {
        buttonRef = 'parkingCardNrInput';
      } else if (event.target && (event.target.classList.contains('vehicleInput-toggle') || event.target.parentElement.classList.contains('vehicleInput-toggle'))) {
        buttonRef = 'vehicleInput';
      }
      if (buttonRef) {
        this[`${buttonRef}Disabled`] = false;
        this.focusInput(buttonRef);
      }
    },
    focusInput(buttonRef) {
      if (!this[`${buttonRef}Disabled`]) {
        this.$nextTick(() => this.$refs[buttonRef].$refs.input.focus());
      }
    },
    blurInput(buttonRef) {
      this.$nextTick(() => this.$refs[buttonRef].$refs.input.blur());
    },
    stopInputAtDashAndSpace(event) {
      if (event.key === '-' || event.key === ' ') {
        event.preventDefault();
        event.stopPropagation();
      }
    },
    checkedDateForPermitChangeDisabled() {
      if (moment().isAfter(moment(this.permit.expirationDate, 'DD.MM.YYYY'), 'day')) {
        this.permitChangeDisabled = true;
      } else {
        this.permitChangeDisabled = false;
      }
    },
    fetchPermit() {
      if (this.$route.params.id && this.user.data) {
        this.$store.dispatch('permits/permit/fetch', { id: this.$route.params.id, user: this.user })
          .then(() => {
            this.form = this.permit;
            this.setPermitRelatedVehicle();
            this.updateMap();
            this.checkedDateForPermitChangeDisabled();
          });
      } else {
        this.$store.commit(`permits/permit/${mTypes.CLEAR_STATE}`);
      }
    },
    fetchVehiclePlateNumbers() {
      if (this.selectedUser) {
        this.$store.dispatch('users/vehicles/fetch', { id: this.selectedUser, user: this.user })
          .then(() => {
            this.fetchUsersVehicles();
            this.vehicles.data.sort((a, b) => this.dynamicSort('id', a, b));
            this.setPermitRelatedVehicle();
          });
      }
    },
    fetchUsersVehicles() {
      this.$store.dispatch('users/user/fetch', { id: this.selectedUser, user: this.user })
        .then(() => {
          const combinedVehicles = this.users.vehicles.map((vehicle) => {
            const currentCar = this.vehicles.data.find(car => car.id === vehicle.id);
            return ({ ...vehicle, ...currentCar });
          });

          this.vehicles.data = combinedVehicles;
        });
    },
    setPermitRelatedVehicle() {
      if (this.permit.vehicle) {
        this.selectedVehicle = this.permit.vehicle;
      } else {
        this.selectedVehicle = { id: null };
      }
    },
    loadMapLayer() {
      Vue.nextTick(() => {
        const id = sha256(JSON.stringify(this.coordinates));
        if (!this.mapInstance.getLayer(`zone-outline-${id}`)) {
          this.mapInstance.addLayer(
            this.cleanupCoordinates(this.coordinates, id));
        }
      });
    },
    parsePhoneNumber(phone, code) {
      return phone
        ? format({ country: code, phone: phone.toString() }, 'International_plaintext')
        : '';
    },
    saveComment(vehicleId) {
      try {
        this.$refs[`confirm-btn-${vehicleId}`][0].disabled = true
        this.$store.dispatch('permits/permit/updateVehicle', {
          vehicleId: vehicleId,
          vehicleComment: this.$refs[`comment-${vehicleId}`][0].value,
          userId: this.selectedUser
        }).then(() => {
          this.fetchVehiclePlateNumbers();
          this.$refs[`confirm-btn-${vehicleId}`][0].disabled = false
          this.activePlate = ''
        })
      } catch (e) {
        console.log('Vehicle comment update error', e)
      }
    },
    onSubmit() {
      if (!this.permitChangeDisabled) {
        this.$validator.validateAll()
          .then((success) => {
            if (success) {
              this.$store.commit(`permits/permit/${mTypes.DATA_ERROR}`, null);
              if (this.form.vehicleReg !== '' && this.form.vehicleReg) {
                this.form.vehicle = { vehicleReg: sanitizeVehicleRegNumber(this.form.vehicleReg) };
              } else if (this.selectedVehicle.id !== null) {
                this.form.vehicle = this.selectedVehicle;
                this.form.vehicleId = this.selectedVehicle.id;
              } else {
                delete this.form.vehicle;
              }
              if (!this.form.parkingCardNr || !this.canUseCards()) {
                this.form.parkingCardNr = null;
              }
              this.form.userId = this.selectedUser;
              this.form.id = this.permit.id;

              // add/update vehicle data
              if (!this.form.vehicleId) {
                this.$store.dispatch('permits/permit/saveNewVehicle', {
                  vehicle_reg: this.form.vehicle.vehicleReg.toUpperCase(),
                  vehicleComment: this.form.vehicleComment,
                  userId: this.selectedUser,
                }).then((response) => {
                  const vehicleId = response.body.data.id;
                  this.form.vehicle.id = vehicleId;
                  this.form.vehicleId = vehicleId;
                  this.savePermit();
                }).catch((error) => {
                  const { message } = error.body;
                  this.showWarningModal = true;
                  this.userWarningHeader = this.$t('common.warning');
                  this.userWarningBody = this.$t(`errors.${message}`);
                })
              } else {
                this.savePermit()
              }
            }
          });
      }
    },
    savePermit() {
      const updatedPermit = {};
      this.$store.dispatch('permits/permit/savePermit', { user: this.user, permit: this.form })
        .then(() => {
          if (!this.permitError) {
            this.isPermitSelected = true;
            updatedPermit.id = this.permit.id; // parseInt(this.$route.params.id, 10);
            updatedPermit.parkingCardNr = this.form.parkingCardNr;
            if (this.form.vehicleReg !== '' && this.form.vehicleReg) {
              updatedPermit.vehicleReg = this.form.vehicleReg;
            } else {
              updatedPermit.vehicleReg = this.selectedVehicle.vehicleReg;
            }
            if (this.permit.product
              && this.permit.product.zones
              && this.permit.product.zones.length > 0) {
              updatedPermit.address = this.permit.product.zones.map(v => `${v.code} (${v.address})`).join(', ');
            } else {
              updatedPermit.address = null;
            }
            if (this.permit.partner) {
              updatedPermit.partnerName = this.permit.partner.name;
            } else {
              updatedPermit.partnerName = null;
            }
            if (this.permit.product) {
              updatedPermit.productName = this.permit.product.name;
            } else {
              updatedPermit.productName = null;
            }
            if (this.permit.user) {
              updatedPermit.userName = this.permit.user.name;
            } else {
              updatedPermit.userName = null;
            }
            if (this.permit.vehicleUpdatedAt) {
              updatedPermit.vehicleUpdatedAt = this.permit.vehicleUpdatedAt;
            } else {
              updatedPermit.vehicleUpdatedAt = null;
            }
            console.log(updatedPermit)
            this.$store.commit(`landlord/permits/${mTypes.EDIT_DATA}`, updatedPermit);
            this.fetchAllData();
            this.form.vehicleReg = '';
            this.parkingCardNrInputDisabled = true;
            this.vehicleInputDisabled = true;
          }
        });
    },
    dynamicSort(property, a, b) {
      if (a[property] < b[property]) {
        return -1;
      } else if (a[property] > b[property]) {
        return 1;
      }
      return 0;
    },
    closeWarningModal() {
      this.showWarningModal = false;
    },
    resetValidators() {
      this.$validator.remove('validParkingCardNr');
      this.$validator.clean();
    },
    createValidators() {
      this.createParkingCardValidator();
    },
    createParkingCardValidator() {
      this.$validator.extend('validParkingCardNr', {
        getMessage: field => `The ${field} value is not valid parking card number.`,
        validate: (value) => {
          if (value === '') {
            return true;
          }
          let input = value.toString();
          const checkNr = input[8];
          input = hexdec(input.substring(0, 8));
          if (`${input}`.length > 8) {
            input = dechex(input);
          }
          input = strpad(input.toString(), 8, '0', 'STR_PAD_LEFT');
          let eventSum = 0;
          let oddSum = 0;
          let i = 0;
          while (i < input.length) {
            const d = hexdec(`${input[i]}`);
            if (i % 2 === 0) {
              oddSum += d;
            } else {
              eventSum += d;
            }
            i += 1;
          }
          const totalSum = (eventSum * 3) + oddSum;
          const nextTen = (Math.ceil(totalSum / 10)) * 10;
          const calculatedCheckNr = nextTen - totalSum;
          return calculatedCheckNr.toString() === checkNr;
        },
      });
    },
    removeVehicle(vehicle) {
      if (vehicle.id === this.primordialSelectedVehicle.id ||
        vehicle.id === this.selectedVehicle.id) {
        this.showWarningModal = true;
        this.userWarningHeader = this.$t('common.warning');
        this.userWarningBody = this.$t('errors.vehicle_in_use');
        return;
      }
      this.$validator.validateAll()
        .then((success) => {
          if (success) {
            this.$store.dispatch('users/vehicles/delete', { id: vehicle.id, user: this.user })
              .then(() => {
                if (!this.vehicleError) {
                  const index = this.vehicles.data.findIndex(obj => obj.id === vehicle.id);
                  this.$delete(this.vehicles.data, index);
                } else {
                  this.showWarningModal = true;
                  this.userWarningHeader = this.$t('common.warning');
                  this.userWarningBody = this.$t(`errors.${this.vehicleError.body.error}`);
                }
              });
            this.$store.commit(`users/vehicles/${mTypes.DATA_ERROR}`, null);
          }
        });
    },
    canUseCards() {
      if (this.permit.product) {
        return this.permit.product.canUseCards;
      }
      return false;
    },
    showListModalVehicle() {
      this.primordialSelectedVehicle = this.selectedVehicle;
      this.showListModal = true;
    },
    closeListModal() {
      this.selectedVehicle = this.primordialSelectedVehicle;
      this.showListModal = false;
      this.onSubmit();
    },
    confirmedListModal() {
      this.primordialSelectedVehicle = this.selectedVehicle;
      this.showListModal = false;
      this.onSubmit();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~styles/app.scss";
@import "~styles/blocks/permit-edit.scss";
@import "~node_modules/leaflet/dist/leaflet.css";

.user-details-container {
  background-color: var(--white);
  display: inline-block;
  margin: 0 0 0 20px;
  padding: 10px 35px;
  flex: 1;

  @media screen and (max-width: 1074px) {
    padding: 10px;
  }

  @media screen and (max-width: 760px) {
    display: none;
  }

  >.content {
    @media screen and (max-width: 1074px) {
      flex-direction: column;
    }
  }

  .product-map {
    @media screen and (max-width: 1074px) {
      flex-direction: column;
      margin-left: 0;
    }

    /*@media screen and (max-width: 760px) {
      display: none;
    }*/
  }

  .details-table__row:nth-child(2) {
    .details-table__col {
      padding-top: 7px;
      vertical-align: top;
    }
  }

  .details-table__row {
    .details-table__col {
      position: relative;
      padding-top: 7px;

      .el-input {
        border-spacing: 0;
        max-width: calc(100% - 4px);
        position: relative;

        &__inner {
          &--vehicle-reg {
            position: relative;
            width: fit-content;
            height: auto;
            line-height: 1.15;
            padding: 10px 15px;
            margin: 2px;
            margin-left: 30px;
            border-radius: 0 4px 4px 0;

            &::after {
              content: '';
              position: absolute;
              top: -1px;
              left: -30px;
              width: 30px;
              height: 40px;
              border: 1px solid #dcdfe6;
              border-radius: 4px 0 0 4px;
              box-sizing: border-box;
            }
          }
        }
      }

      .el-button {

        :not(.btn--change),
        :not(.vehicle-input) {
          width: 54px;
        }
      }
    }
  }
}

.user-details-container.mobile {
  display: inline-block;
  margin: 0 0 10px 0;
  width: 100%;

  @media screen and (min-width: 761px) {
    display: none;
  }
}

.permits-wrapper {
  .permit-details-wrapper {
    .permit-field {
      margin: 15px 0;
      padding: 12.5px 0;
      border-bottom: solid 1.5px var(--grey-four);
      display: flex;
      font-size: 16px;

      .permit-field-description {
        color: var(grey-nine);
        width: 20%;
        text-align: left;
        display: inline-block;
        margin: 0 25px;
        white-space: nowrap;
        font-size: 14px;
      }

      .permit-details {
        color: var(--black);
        font-weight: 900;
        width: 45%;
        text-align: left;
        display: inline-block;
        padding: 0 0 0 35px;
        flex: 1;
      }
    }
  }
}

.el-select {
  i {
    width: 54px;
  }
}

.details-table__row--vehicle {
  display: block;
  height: 100%;
  border: none;

  .details-table__col--vehicle {
    display: flex;
    flex-direction: column;
    padding: 0;
    height: 100%;

    .el-tag {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 40px;
      width: calc(100% - 4px);

      &.el-tag--success {
        background-color: var(--brand-green);
        border: 1px solid var(--brand-green);
        color: white;

        /deep/ .el-tag__close {
          color: white;
        }

        &.el-tag--permit /deep/ .el-tag__close {
          &::before {
            background: url('~icons/number-permit.svg') center/contain no-repeat;
          }
        }
      }

      &.el-tag--permit /deep/ .el-tag__close {
        width: 30px;
        height: 100%;

        &::before {
          content: '';
          background: url('~icons/number-permit-black.svg') center/contain no-repeat;
          height: 100%;
        }
      }
    }

    .vehicle-input {
      max-width: 100%;
      height: auto;
      min-height: 40px;
      margin: 2px;
    }

    .el-input-group {
      margin: 2px;
    }
  }
}
</style>

<style lang="scss">
@import "~styles/app.scss";

.el-button {
  vertical-align: middle;
}

.user-details-container {
  .details-table {
    &__row {
      .el-button {
        padding: 0;
        height: 38px;
        vertical-align: middle;

        span {
          margin: 0;
          white-space: normal;
        }
      }

      .btn {
        &--change {
          display: inline-flex;
          text-transform: uppercase;
          background-color: var(--brand-green);
          color: var(--white);
          padding: 10px 15px;
          vertical-align: top;

          span {
            width: auto !important;
          }
        }
      }

      .el-select {
        width: 100%;
        position: relative;

        input {
          padding-right: 54px;
        }

        i {
          z-index: 2;
          color: #878d99;
        }
      }

      .el-input {
        &__suffix {
          z-index: 2;
          right: 0;
        }
      }

      .tooltip {
        top: 50%;
        right: auto;
        left: 50px;
        z-index: 2000;
        transform: translateY(-50%);
        max-height: none;

        &__content {
          @media screen and (max-width: 1000px) {
            max-height: none;
            height: auto;
            white-space: pre-wrap;
            max-width: 150px;
          }
        }
      }

      .tooltip.to-bottom {
        top: auto;
        bottom: 16px;
        transform: none;
      }

      .el-tag {
        background-color: #f5f7fa;
        border: 1px solid #f5f7fa;
        margin: 2px;
        height: 40px;
        line-height: 40px;
        padding: 0 10px 0 15px;
        color: #000;
        cursor: pointer;

        &__close {
          color: #000;
        }

        &__close:hover {
          background-color: transparent;
        }

        &.el-tag--success {
          background-color: var(--brand-green);
          border: 1px solid var(--brand-green);
          color: white;

          /deep/ .el-tag__close {
            color: white;
          }

          &.el-tag--permit /deep/ .el-tag__close {
            &::before {
              background: url('~icons/number-permit.svg') center/contain no-repeat;
            }
          }
        }

        &.el-tag--permit /deep/ .el-tag__close {
          width: 30px;
          height: 100%;

          &::before {
            content: '';
            background: url('~icons/number-permit-black.svg') center/contain no-repeat;
            height: 100%;
          }
        }
      }

      .el-tag:nth-last-child(2) {
        margin-right: -1px;
      }

      .el-input input {
        text-transform: uppercase;
      }
    }

    &__row:nth-child(2) {
      .el-input {
        margin: 2px;
      }

      .details-table__col {
        >.el-button {
          position: relative;
          padding: 10px 69px 10px 15px;
          border-color: #d8dce5;
          height: auto;
          max-width: 300px;
          margin: 2px;

          span {
            white-space: pre-line;
            line-height: 20px;

            i {
              position: absolute;
              right: 0;
              top: 0;
              height: 100%;
              width: 54px;
              border-left: 1px solid #d8dce5;
              margin-left: 15px;
              vertical-align: top;
              background-color: #f5f7fa;
              border-top-right-radius: 4px;
              border-bottom-right-radius: 4px;
            }

            i:before {
              position: absolute;
              right: 50%;
              top: 50%;
              transform: translate(50%, -50%);
              color: #97a8be;
            }
          }
        }
      }
    }
  }
}

.extend-default-button:after {
  content: "";
  position: absolute;
  top: 1px;
  right: 1px;
  width: 53px;
  height: 38px;
  border-left: 1px solid #d8dce5;
  background-color: #f5f7fa;
  color: #97a8be;
  border-bottom-right-radius: 4px;
  border-top-right-radius: 4px;
  z-index: 1;
}

.extend-default-button {
  .el-input {
    position: relative;

    input {
      padding-left: 56px;
    }

    &:before {
      font: normal normal normal 14px/1 FontAwesome;
      content: "\f041";
      padding: 0 20px;
      color: var(--grey-five);
      left: 0;
      top: 0;
      height: 100%;
      width: 56px;
      position: absolute;
      line-height: 40px;
    }
  }
}

#user-map-dom {
  margin-top: 30px;
  width: 100%;
  height: 300px;
}
</style>



// WEBPACK FOOTER //
// src/components/end-user/EditViewPermit.vue